import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataService } from 'app/shared/services/data.service';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { map } from 'rxjs/operators';
import { ISelect } from 'app/shared/models/select.model';
import { IResult } from 'app/shared/models/result.model';
import { IReference } from 'app/shared/models/recruitment/reference.model';
import { IDtoJobCandidate } from 'app/shared/models/recruitment/dto-job-candidate.model';
import { IDtoJobCandidateFilter } from 'app/shared/models/recruitment/dto-job-candidate-filter.model';
import { IGeneralData } from 'app/shared/models/recruitment/general-data.model';
import { IDocument } from 'app/shared/models/recruitment/document.model';
import 'rxjs/add/observable/of';
import { IEmploymentHistoryItem } from 'app/shared/models/recruitment/employment-history-item.model';
import { IDtoEmployeeContract } from 'app/shared/models/recruitment/dto-employee-contract.model';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { IRecruiterComment } from 'app/shared/models/recruitment/recruiter-comment.model';
import { IAppearance } from 'app/shared/models/recruitment/appearance.model';
import { IEmployeeTaxData } from 'app/shared/models/recruitment/employee-tax-data.model';
import { IDtoEmployeeUpdatePayroll } from 'app/shared/models/employee/dto-employee-update-payroll.model';

@Injectable()
export class RecruitmentService {
    private recruitmentUrl = '';
    private documents: IDocument[] = [
        { documentName: 'ActaNacimiento', title: 'Acta de nacimiento (pdf)-2MB', type: '.pdf', required: true },
        { documentName: 'IdentificacionOficial', title: 'Identificación oficial (pdf)-2MB', type: '.pdf', required: true },
        { documentName: 'ComprobanteDomicilio', title: 'Comprobante de domicilio (pdf)-2MB', type: '.pdf', required: true },
        { documentName: 'Foto', title: 'Foto reciente (jpg, jpeg, png)-2MB', type: '.jpg,.jpeg,.png', required: true },
        { documentName: 'ComprobanteEstudios', title: 'Último comprobante de estudios (pdf)-2MB', type: '.pdf', required: false },
        { documentName: 'CURP', title: 'CURP (pdf)-2MB', type: '.pdf', required: true },
        { documentName: 'RFC', title: 'Constancia fiscal (pdf)-2MB', type: '.pdf', required: true },
        { documentName: 'IMSS', title: 'IMSS (pdf)-2MB', type: '.pdf', required: true },
        { documentName: 'AvisoRetencion', title: 'Aviso de retención (pdf)-2MB', type: '.pdf', required: false },
    ];
    constructor(private service: DataService, private configurationService: ConfigurationService) {
        if (this.configurationService.isReady) {
            this.recruitmentUrl = this.configurationService.serverSettings.recruitmentUrl;
        } else {
            this.configurationService.settingsLoaded$.subscribe(x =>
                this.recruitmentUrl = this.configurationService.serverSettings.recruitmentUrl);
        }
    }

    public addRecluitment(section: string, data: any): Observable<IResult> {
        let url = '';
        switch (section) {
            case 'generalData':
                url = this.recruitmentUrl + 'api/generalData/';
                break;
            case 'study':
                url = this.recruitmentUrl + 'api/jobCandidateLevelEducation/';
                break;
            case 'reference':
                url = this.recruitmentUrl + 'api/jobCandidateReference/';
                break;
            case 'employmentHistory':
                url = this.recruitmentUrl + 'api/jobCandidateEmploymentHistoryes/';
                break;
            case 'recruiterComments':
                url = this.recruitmentUrl + 'api/recruiterComments/';
                break;
        }

        if (data.id === undefined || data.id === null) {
            return this.service.post(url, data).pipe(map((response: any) => {
                return response;
            }));
        } else {
            return this.service.putWithId(url, data).pipe(map((response: any) => {
                return response;
            }));
        }
    }
    public updateRecluitment(section: string, data: any): Observable<IResult> {
        let url = '';
        switch (section) {
            case 'generalData':
                url = this.recruitmentUrl + 'api/generalData/';
                break;
            case 'study':
                url = this.recruitmentUrl + 'api/jobCandidateLevelEducation/';
                break;
            case 'reference':
                url = this.recruitmentUrl + 'api/jobCandidateReference/';
                break;
            case 'employmentHistory':
                url = this.recruitmentUrl + 'api/jobCandidateEmploymentHistoryes/';
                break;
            case 'recruiterComments':
                url = this.recruitmentUrl + 'api/recruiterComments/';
                break;
        }

        if (data.id === undefined || data.id === null) {
            return this.service.post(url, data).pipe(map((response: any) => {
                return response;
            }));
        } else {
            return this.service.putWithId(url, data).pipe(map((response: any) => {
                return response;
            }));
        }
    }
    /**
     * name
     */
    public deleteEmploymentHistoyItem(id: number) {
        const url = `${this.recruitmentUrl}api/JobCandidateEmploymentHistoryItems?id=${id}`;
        return this.service.delete(url).pipe(map((response: any) => {
            return response;
        }));
    }
    public uploadFile(entidad: IDocument, fileToUpload: File): Observable<IResult> {
        const formData = new FormData();
        formData.append('jobCandidateDocumentId', JSON.stringify(entidad));
        formData.append('files', fileToUpload);

        const url = `${this.recruitmentUrl}api/jobCandidateDocuments/uploadFile/`;
        return this.service.post(url, formData).pipe(map((response: any) => {
            return response;
        }));
    }
    public deleteFile(documentId: number): Observable<IResult> {

        const url = `${this.recruitmentUrl}api/jobCandidateDocuments/deleteFile?jobCandidateDocumentId=${documentId}`;
        return this.service.delete(url).pipe(map((response: any) => {
            return response;
        }));
    }
    public downloadFile(documentId: number): Observable<IResult> {

        const url = `${this.recruitmentUrl}api/jobCandidateDocuments/downloadFile?jobCandidateDocumentId=${documentId}`;
        return this.service.get(url).pipe(map((response: any) => {
            return response;
        }));
    }
    public getRfc(firstName: string, lastName: string, secondLastName: string, birthDate: string) {
        const url = `${this.recruitmentUrl}api/generalData/getRFCByJobCandidate?firstName=${firstName}&lastName=${lastName}&secondLastName=${secondLastName}&birthDate=${birthDate}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCurp(firstName: string, lastName: string, secondLastName: string, gender: string, birthDate: string, stateBirthId: number) {
        const url = `${this.recruitmentUrl}api/generalData/getCURPByJobCandidate?firstName=${firstName}&lastName=${lastName}&secondLastName=${secondLastName}&gender=${gender}&birthDate=${birthDate}&stateBirthId=${stateBirthId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogDocumens(): Observable<IDocument[]> {
        return Observable.of(this.documents);
    }
    public getCatalogStates(): Observable<ISelect[]> {
        const url = this.recruitmentUrl + 'api/states/';
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogCountries(): Observable<ISelect[]> {
      const url = this.recruitmentUrl + 'api/contries/';
      return this.service.get(url)
          .pipe(
              map((res: any) => {
                  return res;
              })
          );
  }
    public getCatalogZones(): Observable<ISelect[]> {
        const url = this.recruitmentUrl + 'api/zones/';
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    // public getCatalogTrademarks(): Observable<ISelect[]> {
    //     const url = this.recruitmentUrl + 'api/marks/';
    //     return this.service.get(url)
    //         .pipe(
    //             map((res: any) => {
    //                 return res;
    //             })
    //         );
    // }
    public getCatalogSkills(): Observable<ISelect[]> {
        const url = this.recruitmentUrl + 'api/skills/';
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogMaritalStatus(): Observable<ISelect[]> {
        const url = this.recruitmentUrl + 'api/maritalstatus/';
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogSources(): Observable<ISelect[]> {
        const url = this.recruitmentUrl + 'api/recruitmentSources/';
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogSizes(): Observable<ISelect[]> {
        const url = this.recruitmentUrl + 'api/sizes/';
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogPhysicalComplexions(): Observable<ISelect[]> {
        const url = this.recruitmentUrl + 'api/physicalComplexions/';
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogShirtSizes(): Observable<ISelect[]> {
        const url = this.recruitmentUrl + 'api/ShirtSizes/';
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogPhoneCompanies(): Observable<ISelect[]> {
        const url = this.recruitmentUrl + 'api/PhoneCompanies/';
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogSchoolLevels(): Observable<ISelect[]> {
        const url = this.recruitmentUrl + 'api/schoolLevels/';
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogStatures(): Observable<ISelect[]> {
        const url = this.recruitmentUrl + 'api/statures/';
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogHairColors(): Observable<ISelect[]> {
        const url = this.recruitmentUrl + 'api/hairColors/';
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogEyeColors(): Observable<ISelect[]> {
        const url = this.recruitmentUrl + 'api/eyeColors/';
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogSkinColors(): Observable<ISelect[]> {
        const url = this.recruitmentUrl + 'api/skinColors/';
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogShoeSizes(): Observable<ISelect[]> {
        const url = this.recruitmentUrl + 'api/shoeSizes/';
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogPositions(): Observable<ISelect[]> {
        const url = this.recruitmentUrl + 'api/positions/';
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogEducationLevels(): Observable<ISelect[]> {
        const url = this.recruitmentUrl + 'api/educationLevels/';
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogDocumentsReceived(): Observable<ISelect[]> {
        const url = this.recruitmentUrl + 'api/documentsReceived/';
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogAvailabilitys(): Observable<ISelect[]> {
        const url = this.recruitmentUrl + 'api/availabilitys/';
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogReasonsOfExit(): Observable<ISelect[]> {
        const url = this.recruitmentUrl + 'api/reasonsOfExit/';
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogTrackingStatus(): Observable<ISelect[]> {
        const url = this.recruitmentUrl + 'api/trackingStatus/';
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogRecruiters(): Observable<ISelect[]> {
        const url = this.recruitmentUrl + 'api/recruiters/';
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    /**Información de referencias del candidato */
    public getReferences(jobCandidateId: number): Observable<IReference[]> {
        const url = this.recruitmentUrl + 'api/jobCandidateReference/';
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    /**Información de solicitues, filtro inicial */
    public getJobCandidates(): Observable<IDtoJobCandidate[]> {
        const url = this.recruitmentUrl + 'api/jobCandidates/getJobCandidatesFilter/';
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getJobCandidatesFilters(data: IDtoJobCandidateFilter): Observable<IDtoJobCandidate[]> {
        const url = this.recruitmentUrl + 'api/jobCandidates/GetJobCandidatesFilterByParam/';
        return this.service.post(url, data).pipe(map((response: any) => {
            return response;
        }));
    }
    /**Obtiene un candidato en base a su id */
    public getJobCandidate(jobCandidateId: number): Observable<IGeneralData> {
        const url = this.recruitmentUrl + 'api/generalData/GetById?jobCandidateId=' + jobCandidateId;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogTowns(id: string): Observable<ISelect[]> {
        const url = `${this.recruitmentUrl}api/towns/getTownsByStateId?stateId=${id}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogStateBirth(id: string): Observable<ISelect[]> {
      const url = `${this.recruitmentUrl}api/states/getStatesByContryId?countryId=${id}`;
      return this.service.get(url)
          .pipe(
              map((res: any) => {
                  return res;
              })
          );
  }
    public getCatalogTownsByStateIdCodeNom(id: string): Observable<ISelect[]> {
        const url = `${this.recruitmentUrl}api/towns/getCatalogTownsByStateIdCodeNom?stateId=${id}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogTownsWithStructureByStateId(id: string): Observable<ISelect[]> {
        const url = `${this.recruitmentUrl}api/towns/getCatalogTownsWithStructureByStateId?stateId=${id}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogTownsByStateIdCodeNomStructure(id: string): Observable<ISelect[]> {
        const url = `${this.recruitmentUrl}api/towns/getCatalogTownsByStateIdCodeNomStructure?stateId=${id}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    /**Download excel */
    public getCandidatesExcel(data: IDtoJobCandidateFilter): Observable<IResult> {
        const url = `${this.recruitmentUrl}api/JobCandidateDocuments/DownloadExcel/`;
        return this.service.post(url, data).pipe(map((response: any) => {
            return response;
        }));
    }
    /**Update employment history item */
    public updateEmploymentHistoryItem(data: IEmploymentHistoryItem): Observable<IResult> {
        const url = `${this.recruitmentUrl}api/JobCandidateEmploymentHistoryItems/`;
        return this.service.putWithId(url, data).pipe(map((response: any) => {
            return response;
        }));
    }
    public jobCandidatesContract(data: IDtoEmployeeContract): Observable<IResult> {
        const url = `${this.recruitmentUrl}api/JobCandidates/jobCandidatesContract/`;
        return this.service.post(url, data).pipe(map((response: any) => {
            return response;
        }));
    }
    public downloadFileEmployeeTxt(data: any): Observable<IResult> {
        const url = `${this.recruitmentUrl}api/JobCandidates/jobCandidateFileTXT/`;
        return this.service.post(url, data).pipe(map((response: any) => {
            return response;
        }));
    }
    public getJobCandidateDocumentsByJobCandidateId(jobCandidateId: number): Observable<IDocument[]> {
        const url = `${this.recruitmentUrl}api/JobCandidateDocuments/getJobCandidateDocumentsByJobCandidateId?jobCandidateId=${jobCandidateId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogPatrimonialRegimes(): Observable<IDtoCatalog[]> {
        const url = this.recruitmentUrl + 'api/PatrimonialRegimes/getCatalogPatrimonialRegimes';
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCandidatePositionType(jobCandidateId: number): Observable<string> {
        const url = `${this.recruitmentUrl}api/JobCandidates/getCandidatePositionType?jobCandidateId=${jobCandidateId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getJobCandidateId(id: string): Observable<number> {
        const url = `${this.recruitmentUrl}api/GeneralData/getJobCandidateId?id=${id}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCandidatesRechargeableByRequisitionId(requisitionId: number): Observable<IDtoCatalog[]> {
        const url = `${this.recruitmentUrl}api/JobCandidates/getCandidatesRechargeableByRequisitionId?requisitionId=${requisitionId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public updateTrackingStatusJobCandidate(candidate: IRecruiterComment): Observable<IResult> {
        const url = `${this.recruitmentUrl}api/JobCandidates/updateTrackingStatusJobCandidate`;
        return this.service.putWithId(url, candidate)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCandidateHasInfonavit(jobCandidateId: number): Observable<string> {
        const url = `${this.recruitmentUrl}api/JobCandidates/getCandidateHasInfonavit?jobCandidateId=${jobCandidateId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getJobCandidateAppearanceByJobCandidateId(jobcandidateId: number): Observable<IAppearance> {
        const url = `${this.recruitmentUrl}api/JobCandidateAppearance/getJobCandidateAppearanceByJobCandidateId?jobcandidateId=${jobcandidateId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public updateJobCandidateAppearance(data: IAppearance): Observable<IResult> {
        const url = `${this.recruitmentUrl}api/JobCandidateAppearance/`;
        return this.service.putWithId(url, data).pipe(map((response: any) => {
            return response;
        }));
    }
    public addJobCandidateAppearance(data: IAppearance): Observable<IResult> {
        const url = `${this.recruitmentUrl}api/JobCandidateAppearance/`;
        return this.service.post(url, data).pipe(map((response: any) => {
            return response;
        }));
    }
    public getCatalogPhonePlans(): Observable<ISelect[]> {
        const url = this.recruitmentUrl + 'api/PhonePlans/';
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public updateTaxDataEmployee(data: IDtoEmployeeUpdatePayroll): Observable<IResult> {
        const url = `${this.recruitmentUrl}api/Employees/updateTaxDataEmployee`;
        return this.service.putWithId(url, data).pipe(map((response: any) => {
            return response;
        }));
    }
    public getCandidateInduction(jobCandidateId: number, requisitionId: number): Observable<IResult> {
      const url = `${this.recruitmentUrl}api/JobCandidates/getCandidateInduction?jobCandidateId=${jobCandidateId}&RequisitionId=${requisitionId}`;
      return this.service.get(url)
          .pipe(
              map((res: any) => {
                  return res;
              })
          );
    }
    public getJobCandidateDocument(jobCandidateId: number, documentName: string): Observable<IDocument> {
        const url = `${this.recruitmentUrl}api/jobCandidateDocuments/getJobCandidateDocument?jobCandidateId=${jobCandidateId}&documentName=${documentName}`;
        return this.service.get(url).pipe(map((response: any) => {
            return response;
        }));
    }
    public uploadFileAndTaxDataEmployee(entidad: IResult, fileToUpload: File): Observable<IResult> {
        const formData = new FormData();
        formData.append('result', JSON.stringify(entidad));
        formData.append('files', fileToUpload);

        const url = `${this.recruitmentUrl}api/jobCandidateDocuments/uploadFileAndTaxDataEmployee/`;
        return this.service.post(url, formData).pipe(map((response: any) => {
            return response;
        }));
    }
}
